import React from "react";
import { Method } from "./Method";
import { CreditState } from "../../../stores/credit/credit-state.interface";
import { useCreditDispatch } from "../../../stores/credit/credit.store";
import { setShippingMethod } from "../../../stores/credit/credit.reducer";
import { useCreditSelector } from "../../../stores/product/product.store";
import { ShippingMethodInterface } from "../../../interfaces/credit/shipping-method.interface";

interface MethodsProps {
    methods: ShippingMethodInterface[];
}
export const Methods: React.FC<MethodsProps> = ({ methods }) => {
    const selectShippingMethod = useCreditSelector((state: CreditState) => state.shipping.selectShippingMethod);
    const dispatch = useCreditDispatch();

    const select = (method: ShippingMethodInterface) => {
        dispatch(setShippingMethod(method));
    }

    return (
        <div className="grid grid-cols-2 gap-4">
            { methods.map(method => <Method key={ method.code } method={ method }
                                                    isSelected={ selectShippingMethod?.code === method.code }
                                                    onChange={ select }/>) }
        </div>
    )
}